export const ENV = (() => {
  const runtimeEnv = (window as any).ENV;
  const buildTimeEnv = process.env;
  const isProduction = buildTimeEnv.DEPLOY_ENV === 'production';
  const hcaptchaTestSitekey = '20000000-ffff-ffff-ffff-000000000002';
  const hcaptchaSitekey =
    isProduction && buildTimeEnv.HCAPTCHA_SITEKEY
      ? buildTimeEnv.HCAPTCHA_SITEKEY
      : hcaptchaTestSitekey;

  return {
    /**
     * These environment variables are set dynamically via JS script injection
     */

    APP_ID: runtimeEnv.APP_ID,
    BASE_DOMAIN: runtimeEnv.BASE_DOMAIN,
    SNOWPLOW_COLLECTOR_URL: runtimeEnv.SNOWPLOW_COLLECTOR_URL,
    API_URL: runtimeEnv.API_URL,

    /**
     * These environment variables are defined during project build time
     */

    API_PROXY_URL: buildTimeEnv.API_PROXY_URL,
    DEPLOY_ENV: buildTimeEnv.DEPLOY_ENV,
    NODE_ENV: buildTimeEnv.NODE_ENV,
    NPM_PACKAGE_VERSION: buildTimeEnv.NPM_PACKAGE_VERSION,

    /**
     * Test key is used for non-production deploy environments.
     *
     * If HCAPTCHA_SITEKEY is absent for some reason, use `safe-end-user` test key.
     * This is a bad scenario, but still better than blocking chauffeurs from accessing the app.
     *
     * Refer to https://docs.hcaptcha.com/#integration-testing-test-keys.
     */
    HCAPTCHA_SITEKEY: hcaptchaSitekey,

    /**
     * The softer key for sends still within the profile's invisible budget;
     * HCAPTCHA_SITEKEY is the strict one for when the budget is spent.
     *
     * Without its own secret it falls back to HCAPTCHA_SITEKEY, so every send
     * gets the strict check rather than none. Same test key outside production.
     */
    HCAPTCHA_INVISIBLE_SITEKEY:
      isProduction && buildTimeEnv.HCAPTCHA_INVISIBLE_SITEKEY
        ? buildTimeEnv.HCAPTCHA_INVISIBLE_SITEKEY
        : hcaptchaSitekey,

    /**
     * These are hardcoded environment variables
     */

    SENTRY_DSN: 'https://c9e009464d0a46dda47f79f8e4ba713d@o18635.ingest.sentry.io/6111528',
  };
})();
